
<div class="regulations-page">

  <!-- Intestazione -->
  <div class="page-heading">
    <div class="heading-icon">
      <i class="pi pi-file"></i>
    </div>

    <div class="heading-content">
      <h2>Gestione normative</h2>
      <p>
        Consulta le risposte degli iscritti e gestisci
        le normative sulla privacy.
      </p>
    </div>
  </div>

  <!-- Scheda principale -->
  <div class="regulations-card">

    <p-table
      #dt
      [value]="subscribers"
      [scrollable]="true"
      scrollDirection="both"
      scrollHeight="flex"
      [globalFilterFields]="['name', 'lastName']"
      styleClass="regulations-table p-datatable-sm"
      [style]="{ width: '100%', height: '100%' }"
    >

      <!-- Barra strumenti -->
      <ng-template pTemplate="caption">
        <div class="table-toolbar">

          <div class="toolbar-title">
            <h3>Lista normative accettate</h3>
            <span class="toolbar-subtitle">
              Visualizza i consensi registrati per ciascun iscritto
            </span>
          </div>

          <div class="toolbar-actions">

            <span class="p-input-icon-left search-wrapper">
              <i class="pi pi-search"></i>

              <input
                pInputText
                type="text"
                [(ngModel)]="search"
                (ngModelChange)="dt.filterGlobal(search, 'contains')"
                placeholder="Cerca iscritto..."
                class="search-input"
              />
            </span>

            <button
              pButton
              type="button"
              icon="pi pi-refresh"
              label="Aggiorna"
              class="p-button-outlined refresh-button"
              (click)="loadRegulations()"
            ></button>

            <button
              pButton
              type="button"
              icon="pi pi-plus"
              label="Nuova normativa"
              class="create-button"
              (click)="createNewRegulation()"
            ></button>

          </div>
        </div>
      </ng-template>

      <!-- Intestazione tabella -->
      <ng-template pTemplate="header">
        <tr>

          <th class="subscriber-column">
            <div class="column-heading">
              <i class="pi pi-user"></i>
              <span>Nome e cognome</span>
            </div>
          </th>

          <ng-container *ngFor="let regulation of regulations">
            <th class="regulation-column">
              <div class="regulation-heading">

                <span
                  class="regulation-title"
                  [title]="regulation.title"
                >
                  {{ regulation.title }}
                </span>

                <button
                  pButton
                  type="button"
                  icon="pi pi-trash"
                  class="p-button-danger p-button-outlined p-button-sm delete-button"
                  [attr.aria-label]="'Elimina normativa ' + regulation.title"
                  [title]="'Elimina normativa: ' + regulation.title"
                  (click)="removeRegulation(regulation)"
                ></button>

              </div>
            </th>
          </ng-container>

        </tr>
      </ng-template>

      <!-- Righe -->
      <ng-template pTemplate="body" let-subscriber>
        <tr>

          <td class="subscriber-cell">
            <div class="subscriber-name">
              <span class="subscriber-avatar">
                <i class="pi pi-user"></i>
              </span>

              <span>
                {{ subscriber.name }} {{ subscriber.lastName }}
              </span>
            </div>
          </td>

          <ng-container
            *ngFor="let regulation of regulations; index as index"
          >
            <td class="answer-cell">

              <ng-container
                *ngIf="
                  subscriber.regulations &&
                  subscriber.regulations.length > 0 &&
                  subscriber.regulations[index];
                  else noAnswer
                "
              >
                <span class="answer-text">
                  {{ subscriber.regulations[index].acceptanceAnswer }}
                </span>
              </ng-container>

              <ng-template #noAnswer>
                <span class="answer-empty">—</span>
              </ng-template>

            </td>
          </ng-container>

        </tr>
      </ng-template>

      <!-- Tabella vuota -->
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="regulations.length + 1">
            <div class="empty-state">
              <i class="pi pi-users"></i>
              <h4>Nessun iscritto trovato</h4>
              <p>
                Non ci sono risultati corrispondenti alla ricerca.
              </p>
            </div>
          </td>
        </tr>
      </ng-template>

    </p-table>

  </div>
</div>

<!-- =====================================
     DIALOG CREAZIONE NORMATIVA
===================================== -->

<p-dialog
  header="Nuova normativa"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  [modal]="true"
  [visible]="creating !== undefined"
  [style]="{
    width: 'calc(100vw - 32px)',
    maxWidth: '650px',
    maxHeight: 'calc(100vh - 32px)',
    borderRadius: '16px',
    overflow: 'hidden'
  }"
  [contentStyle]="{
    overflowY: 'auto'
  }"
  styleClass="create-regulation-dialog"
>

  <div
    *ngIf="creating !== undefined"
    class="create-regulation-content"
  >

    <!-- Introduzione -->
    <div class="create-intro">
      <div class="create-intro-icon">
        <i class="pi pi-file-edit"></i>
      </div>

      <div>
        <h3>Dettagli della normativa</h3>
        <p>
          Inserisci le informazioni e configura le risposte
          disponibili per gli iscritti.
        </p>
      </div>
    </div>

    <!-- Titolo -->
    <div class="form-field">
      <label for="regulation-title">
        Titolo normativa
      </label>

      <input
        id="regulation-title"
        pInputText
        type="text"
        [(ngModel)]="creating.title"
        placeholder="Inserisci il titolo"
        class="form-input"
      />
    </div>

    <!-- Descrizione -->
    <div class="form-field">
      <label for="regulation-description">
        Descrizione
      </label>

      <textarea
        id="regulation-description"
        pInputTextarea
        [(ngModel)]="creating.description"
        rows="5"
        placeholder="Inserisci il testo della normativa"
        class="form-textarea"
      ></textarea>
    </div>

    <!-- Risposte -->
    <div class="form-section-title">
      <i class="pi pi-check-square"></i>
      <span>Opzioni di risposta</span>
    </div>

    <div class="form-field">
      <label for="regulation-accept">
        Testo di accettazione
      </label>

      <input
        id="regulation-accept"
        pInputText
        type="text"
        [(ngModel)]="creating.acceptAnswer"
        placeholder="Es. Presto il mio consenso"
        class="form-input"
      />
    </div>

    <div class="form-field">
      <label for="regulation-reject">
        Testo di rifiuto
      </label>

      <input
        id="regulation-reject"
        pInputText
        type="text"
        [(ngModel)]="creating.rejectAnswer"
        placeholder="Es. Non presto il mio consenso"
        class="form-input"
      />
    </div>

    <!-- Risposta obbligatoria -->
    <div class="mandatory-answer-card">
      <div class="mandatory-answer-text">
        <h4>Risposta obbligatoria</h4>
        <p>
          Seleziona quale delle due risposte sarà richiesta
          per proseguire.
        </p>
      </div>

      <p-toggleButton
        [(ngModel)]="useAccept"
        [onLabel]="'Usa: ' + creating.acceptAnswer"
        [offLabel]="'Usa: ' + creating.rejectAnswer"
        styleClass="mandatory-toggle"
      ></p-toggleButton>
    </div>

    <!-- Azioni -->
    <div class="dialog-actions">

      <button
        pButton
        type="button"
        icon="pi pi-times"
        label="Annulla"
        class="p-button-outlined p-button-secondary"
        (click)="creating = undefined"
      ></button>

      <button
        pButton
        type="button"
        icon="pi pi-check"
        label="Conferma"
        [disabled]="!canCreate"
        (click)="confirmCreate()"
      ></button>

    </div>

  </div>
</p-dialog>
